import mixpanel from 'mixpanel-browser';

export default class EventService {
  static initialiseMixpanel(){
    console.log("Initialising Mixpanel");
    const appId = process.env.REACT_APP_MIXPANEL_APP_ID;
    
    if(appId !== null){
      mixpanel.init(appId, {
      cross_subdomain_cookie: false,
      persistence: 'localStorage'
    });
    }
  }

  static trackEvent(name, props) {
    mixpanel.track(name, props);
  }

  static getMixpanelDistinctId() {
    return mixpanel.get_distinct_id();
  }
}